<template>
<div>
   <div class="row bgc-wrapper margin-top-42">
    <div class="col-12 traveller-heading accordion-toggle">
      <div class="row">
        <div>
          <button
            id = "corresp_address"
            type="button"
            class="expand-form-button"
            data-toggle="collapse"
            aria-label="Expand correspondence-address"
            data-target="#CorrespondenceAddress"
          >
            <img alt="Toggle correspondence-address" src="@/assets/images/arr-up.png" />
          </button>
        </div>
        <h3>Correspondence Address</h3>
        <div class="col-lg-8 col-md-8 col-sm-12 d-flex pl-md-0 pl-sm-0 pl-lg-0">
            <!--  @click="hidePresentAdd()" -->
            <input type="checkbox" class="bgc-checkbox" id="check1" @click="hidePresentAdd()" v-model="addressData.hidePermanentAddress" />
            <label class="checkbox-inline form-check-label ml-lg-0 ml-md-2" for="check1">
              <small class="check ml-2">Permanent Address same as Correspondence Address</small>
            </label>
        </div>
      </div>
    </div>
    <div class="collapse show col-lg-12 col-md-12 col-sm-12 bgc-form-box" id="CorrespondenceAddress">
    <!--Correspondence Address start-->
    <!-- getLanguage.CorrespondenceAddress.address -->
    <div class="row">
        <!-- Address starts-->
        <div class="col-lg-3 col-md-3 col-sm-6">
            <div class="row form-group">
            <float-label 
                label="Address*" 
                :fixed="isFloat(addressData.correspondenceAddress.addressLine1.value)">
                <input
                type="text"
                class="form-control"
                placeholder="Address*"
                @change="changeEncryptionValidation(addressData.correspondenceAddress.addressLine1)"
                maxlength="240"
                v-on:keydown="addressOnly"
                v-model="addressData.correspondenceAddress.addressLine1.value"
                :class="{ 'bgc-error-field': addressData.correspondenceAddress.addressLine1.errorText!=='' }"
                v-evolvews="addressData.correspondenceAddress.addressLine1"
                />
            </float-label>
            <span
                class="error-text"
                v-if="addressData.correspondenceAddress.addressLine1.errorText!==''"
            >{{addressData.correspondenceAddress.addressLine1.errorText}}</span>
            </div>
        </div>
        <!-- Address end-->
        <!-- Pincode starts-->
        <div class="col-lg-3 col-md-3 col-sm-6">
            <div class="row form-group">
                <!-- @blur="callGetAreaByPinCode()" -->
            <float-label 
                label="Pincode*" 
                :fixed="isFloat(addressData.correspondenceAddress.pincode.value)">
                <input
                :disabled="selectedEndrsType=='nilCorrCustomerDetail'"
                type="text"
                class="form-control"
                placeholder="Pincode*"
                @change="callGetAreaByPinCode('fromNil','correspondenceAddress')"
                v-model="addressData.correspondenceAddress.pincode.value"
                maxlength="6"
                @input='onlyNumberMotor($event,addressData.correspondenceAddress.pincode)'
                :class="{ 'bgc-error-field': addressData.correspondenceAddress.pincode.errorText!=='' }"
                v-evolvews="addressData.correspondenceAddress.pincode"
                />
            </float-label>
            <span
                class="error-text"
                v-if=" addressData.correspondenceAddress.pincode.errorText!==''"
            >{{ addressData.correspondenceAddress.pincode.errorText}}</span>
            </div>
        </div>
        <!-- Pincode end-->
        <!-- City starts-->
        <div class="col-lg-3 col-md-3 col-sm-6">
            <div class="row form-group">
            <float-label 
                label="City*" 
                :fixed="isFloat(addressData.correspondenceAddress.city.value)">
                <input
                disabled
                type="text"
                class="form-control"
                placeholder="City*"
                v-on:keydown="onlyChar"
                v-model="addressData.correspondenceAddress.city.value"
                :class="{ 'bgc-error-field': addressData.correspondenceAddress.city.errorText!=='' }"
                v-evolvews="addressData.correspondenceAddress.city"
                />
            </float-label>
            <span
                class="error-text"
                v-if=" addressData.correspondenceAddress.city.errorText!==''"
            >{{ addressData.correspondenceAddress.city.errorText}}</span>
            </div>
        </div>
        <!-- City end-->
        <!-- Area starts-->
        <div class="col-lg-3 col-md-3 col-sm-6">
            <div class="row form-group">
            <float-label
                label="Area*"
                :fixed="isFloat(addressData.correspondenceAddress.area.value)"
            >
                <select
                class="form-control"
                placeholder="Area*"
                :class="{ 'bgc-error-field': addressData.correspondenceAddress.area.errorText!=='' }"
                v-evolvews="addressData.correspondenceAddress.area"
                v-model="addressData.correspondenceAddress.area.value"
                >
                <option disabled value='' v-if="addressData.correspondenceAddress.area.value==''">Area*</option>
                <option disabled :value='null' v-if="addressData.correspondenceAddress.area.value==null">Area*</option>
                <option
                    v-for="area in areas"
                    :key="area.areaCode"
                    :value="area.areaCode"
                >{{area.areaName}}</option>
                </select>
            </float-label>
            <span
                class="error-text"
                v-if="addressData.correspondenceAddress.area.errorText!==''"
            >{{ addressData.correspondenceAddress.area.errorText}}</span>
            </div>
        </div>
        <!-- Area end-->
    </div>
    <div class="row">    
        <!-- State* starts-->
        <div class="col-lg-3 col-md-3 col-sm-6">
            <div class="row form-group">
            <float-label 
                label="State*" 
                :fixed="isFloat(addressData.correspondenceAddress.state.value)">
                <input
                disabled
                type="text"
                class="form-control"
                placeholder="State*"
                v-on:keydown="onlyChar"
                v-model="addressData.correspondenceAddress.state.value"
                :class="{ 'bgc-error-field': addressData.correspondenceAddress.state.errorText!=='' }"
                v-evolvews="addressData.correspondenceAddress.state"
                />
            </float-label>
            <span
                class="error-text"
                v-if=" addressData.correspondenceAddress.state.errorText!==''"
            >{{ addressData.correspondenceAddress.state.errorText}}</span>
            </div>
        </div>
        <!-- State end-->
        <!--E-mail* starts-->
        <div class="col-lg-3 col-md-3 col-sm-6" v-if="selectedEndrsType == 'transferOfOwnership'">
            <div class="row form-group">
                <float-label label="E-mail*" :fixed="isFloat(addressData.correspondenceAddress.emailId.value)"> 
                    <input
                        v-model="addressData.correspondenceAddress.emailId.value"
                        v-evolvews="addressData.correspondenceAddress.emailId"
                        type="text"
                        @blur="checkValidationEmailAndMobile()"
                        :class="{'bgc-error-field':addressData.correspondenceAddress.emailId.errorText !== ''}"
                        class="form-control"
                        placeholder="E-mail*"
                    />
                </float-label>
                <span class="error-text" v-if="addressData.correspondenceAddress.emailId.errorText !== ''">
                    {{addressData.correspondenceAddress.emailId.errorText}}</span>
            </div>
        </div>
        <!--E-mail* ends-->
        <!--Mobile Number* starts-->
        <div class="col-lg-3 col-md-3 col-sm-6" v-if="selectedEndrsType == 'transferOfOwnership'">
            <div class="row form-group">
                <float-label label="Mobile Number*" :fixed="isFloat(addressData.correspondenceAddress.mobileNo.value)"> 
                    <input
                        v-model="addressData.correspondenceAddress.mobileNo.value"
                        v-evolvews="addressData.correspondenceAddress.mobileNo"
                        type="text"
                        v-on:keydown="onlyNumber"
                        maxlength="10"
                        @blur="checkValidationEmailAndMobile()"
                        :class="{'bgc-error-field':addressData.correspondenceAddress.mobileNo.errorText !== ''}"
                        class="form-control"
                        placeholder="Mobile Number*"
                    />
                </float-label>
                <span class="error-text" v-if="addressData.correspondenceAddress.mobileNo.errorText !== ''">
                    {{addressData.correspondenceAddress.mobileNo.errorText}}</span>
            </div>
        </div>
        <!--Mobile Number* ends-->
    </div>
    <div class="row" v-if="selectedEndrsType == 'transferOfOwnership'">    
        <!-- Insured’s PAN starts -->
        <div class="col-lg-3 col-md-3 col-sm-6 ">
          <div class="row form-group">
          <float-label
            label="Insured’s PAN"
            :fixed="isFloat(addressData.correspondenceAddress.panNumber.value)"
          >
            <input
              type="text"
              placeholder="Insured’s PAN"
              maxlength="10"
              v-on:keyup="alphaNumeric;toUpperCase()"
              class="form-control pan-input"
              @change="resetPanText()"
              v-evolvews="addressData.correspondenceAddress.panNumber"
              v-model="addressData.correspondenceAddress.panNumber.value"
              :class="{ 'bgc-error-field': addressData.correspondenceAddress.panNumber.errorText!=='' }"
            />
          </float-label>
          <span class="pan-validated" :class="{'success-pan':(panValidate!=='Unsuccessful' && panValidate!=='Please enter a PAN before proceeding')}" 
            v-show="!addressData.correspondenceAddress.panNumber.errorText && panValidate">{{panValidate}}<span class="font-weight-bold">{{panNameStatus}}</span></span>
          <span
            class="error-text" v-if="addressData.correspondenceAddress.panNumber.errorText !== ''" >
            {{addressData.correspondenceAddress.panNumber.errorText}}</span>
          <span v-if="validatePanLoader" class="search-loader small inline"><img src="@/assets/images/loader.gif" alt="Pan Loader"
            class="search-loader-breakdown"/></span>
          </div>
        </div>
        <!-- Insured’s PAN ends -->
        <div class="col-lg-3 col-md-3 col-sm-6 pr-0">
          <div class="row form-group pan-search-div ml-0">
            <a
              href="#"
              class="add-wrapper bgc-links pan-search "
              data-toggle="collapse"
              @click="validatePan()"
              data-target="#validatePan"
            >Validate PAN Number</a>
          </div>
        </div>
        <div class="form-group col-lg-3 col-md-3 col-sm-6 blank-div"></div>
    </div>
    <!--Correspondence Address end-->
    
    </div>
    </div>
    <!--Permanent Address start  -->
    <div class="col-lg-12 col-md-12 col-sm-12  traveller-heading accordion-toggle mt-5" v-if="!addressData.hidePermanentAddress" >
    <div class="row">
        <div>
            <button
            type="button"
            class="expand-form-button"
            data-toggle="collapse"
            aria-label="Expand permanent-address"
            data-target="#permanent_address"
            >
            <img alt="Toggle permanent-address" src="@/assets/images/arr-up.png" />
            </button>
        </div>
        <h3>Permanent Address</h3>
    </div>
    </div>
    <div class="collapse show col-lg-12 col-md-12 col-sm-12 bgc-form-box" id="permanent_address" v-if="!addressData.hidePermanentAddress">
    <!-- Address* starts-->
    <div class="row">
        <div class="col-lg-3 col-md-3 col-sm-6">
        <div class="row form-group">
            <!-- getLanguage.PermanentAddress.address -->
        <float-label 
            label="Address*" 
            :fixed="isFloat(addressData.permanentAddress.addressLine1.value)">
            <input
            type="text"
            class="form-control"
            placeholder="Address*"
            @change="changeEncryptionValidation(addressData.permanentAddress.addressLine1)"
            v-model="addressData.permanentAddress.addressLine1.value"
            maxlength="240"
            v-on:keydown="addressOnly"
            :class="{ 'bgc-error-field': addressData.permanentAddress.addressLine1.errorText!=='' }"
            v-evolvews="addressData.permanentAddress.addressLine1"
            />
        </float-label>
        <span
            class="error-text"
            v-if="addressData.permanentAddress.addressLine1.errorText!==''"
        >{{addressData.permanentAddress.addressLine1.errorText}}</span>
        </div>
        </div>
        <!-- Address end-->
        <!-- Pincode* starts-->
        <div class="col-lg-3 col-md-3 col-sm-6">
        <div class="row form-group">
        <float-label 
            label="Pincode*" 
            :fixed="isFloat(addressData.permanentAddress.pincode.value)">
            <input
            type="text"
            class="form-control"
            placeholder="Pincode*"
            @change="callGetAreaByPinCode('fromNil','permanentAddress')"
            v-model="addressData.permanentAddress.pincode.value"
            maxlength="6"
            @input='onlyNumberMotor($event,addressData.permanentAddress.pincode)'
            :class="{ 'bgc-error-field': addressData.permanentAddress.pincode.errorText!=='' }"
            v-evolvews="addressData.permanentAddress.pincode"
            />
        </float-label>
        <span
            class="error-text"
            v-if=" addressData.permanentAddress.pincode.errorText!==''"
        >{{ addressData.permanentAddress.pincode.errorText}}</span>
        </div>
        </div>
        <!-- Pincode end-->
        <!-- City* starts-->
        <div class="col-lg-3 col-md-3 col-sm-6">
        <div class="row form-group">
        <float-label 
            label="City*" 
            :fixed="isFloat(addressData.permanentAddress.city.value)">
            <input
            type="text"
            :disabled="true"
            class="form-control"
            placeholder="City*"
            v-on:keydown="onlyChar"
            v-model="addressData.permanentAddress.city.value"
            :class="{ 'bgc-error-field': addressData.permanentAddress.city.errorText!=='' }"
            v-evolvews="addressData.permanentAddress.city"
            />
        </float-label>
        <span
            class="error-text"
            v-if=" addressData.permanentAddress.city.errorText!==''"
        >{{ addressData.permanentAddress.city.errorText}}</span>
        </div>
        </div>
        <!-- City end-->
        <!-- Area* starts-->
        <div class="col-lg-3 col-md-3 col-sm-6">
        <div class="row form-group">
        <float-label 
            label="Area*" 
            :fixed="isFloat(addressData.permanentAddress.area.value)">
            <select
            class="form-control"
            placeholder="Area*"
            v-model="addressData.permanentAddress.area.value"
            :class="{ 'bgc-error-field': addressData.permanentAddress.area.errorText!=='' }"
            v-evolvews="addressData.permanentAddress.area"
            >
            <option disabled value='' v-if="addressData.permanentAddress.area.value==''">Area*</option>
            <option disabled :value='null' v-if="addressData.permanentAddress.area.value==null">Area*</option>
            <option
                v-for="area in permanentAreas"
                :key="area.areaCode"
                :value="area.areaCode"
            >{{area.areaName}}</option>
            </select>
        </float-label>
        <span
            class="error-text"
            v-if=" addressData.permanentAddress.area.errorText!==''"
        >{{ addressData.permanentAddress.area.errorText}}</span>
        </div>
        </div>
        <!-- Area end-->
    </div>
    <div class="row">    
        <!-- State* starts-->
        <div class="col-lg-3 col-md-3 col-sm-6">
            <div class="row form-group">
            <float-label 
                label="State*" 
                :fixed="isFloat(addressData.permanentAddress.state.value)">
                <input
                disabled
                type="text"
                class="form-control"
                placeholder="State*"
                v-on:keydown="onlyChar"
                v-model="addressData.permanentAddress.state.value"
                :class="{ 'bgc-error-field': addressData.permanentAddress.state.errorText!=='' }"
                v-evolvews="addressData.permanentAddress.state"
                />
            </float-label>
            <span
                class="error-text"
                v-if=" addressData.permanentAddress.state.errorText!==''"
            >{{ addressData.permanentAddress.state.errorText}}</span>
            </div>
        </div>
        <!-- State end-->
    </div>
    <div class="form-group col-lg-3 col-md-3 col-sm-6 blank-div"></div>
    </div>
    <!--Permanent Address end-->
</div>
</template>

<script>
import FloatLabel from "@/../shared_component/FloatLabel.vue";
import Datepicker from "vuejs-datepicker";
import functions from "@/../../masters/functions.js";
// import base from "@/../../masters/base.js";
// import Breadcrumb from "@/../../shared_component/Breadcrumb.vue";
// import vSelect from "vue-select";
import { reactive, onUpdated, onMounted, watch} from "@vue/composition-api";
export default {
  name: "CorrespondenceAddress",
  props: ["addressData",'areas','panNameStatus','validatePanLoader','permanentAreas','selectedEndrsType','panValidate'],
  components: {
    FloatLabel,
    Datepicker
  },
  setup(props, context) {
    let state = reactive({});
    // onMounted
    onMounted(()=>{
        hidePresentAdd('onMounted');
        checkValidationEmailAndMobile();
    });
    const checkError = functions.checkError;
    const isInputError = functions.isInputError;
    const isFloat = functions.isFloat;
    const onlyNumber = functions.onlyNumber;
    const onlyCharSpace = functions.onlyCharSpace;
    const onlyChar = functions.onlyChar;
    const addressOnly = functions.addressOnly;
    const alphaNumeric =  functions.alphaNumeric;
    const alphaNumericSpace= functions.alphaNumericSpace;
    // const getLanguage= base.labelProcessor.get_labels();

    onUpdated(()=>{
        if(props.selectedEndrsType == 'nilCorrCustomerDetail')
            context.parent.enableCalculatePremiumBtn('nilCorrCustomerDetail');
        context.parent.calculateSteps();
    })
    function hidePresentAdd(calledFrom) {
        if(calledFrom !== 'onMounted'){
            props.addressData.hidePermanentAddress = !props.addressData.hidePermanentAddress; // To resolve the double tick issue
        }
        Object.values(props.addressData.permanentAddress).forEach(attr => {
            if(props.addressData.hidePermanentAddress){
                context.root.$set(attr,'skip',true); // to add skip attribute to each object
                context.root.$set(attr,'stepsMandatory',false);
            }
            else{
                delete attr.skip; // to delete skip attribute from each object
                context.root.$set(attr,'stepsMandatory',true);
            }
        });
        context.parent.calculateSteps();
    }
    function validatePan(){
        if(!props.addressData.correspondenceAddress.panNumber.errorText)
            context.parent.validatePan();
    }
    function resetPanText(){
        context.parent.resetPanText();
    }
    function callGetAreaByPinCode(calledFrom, addressDetail){
        if(Object.keys(props.addressData.correspondenceAddress.pincode.value).length == 6 || Object.keys(props.addressData.permanentAddress.pincode.value).length == 6){
            context.parent.getAreaDetailsByPinCode(calledFrom,addressDetail);
        }
    }
    function changeEncryptionValidation(obj){
        if(props.selectedEndrsType == 'nilCorrCustomerDetail')
            context.parent.changeEncryptionValidation(obj);
    }
    function onlyNumberMotor(e,targetObj){
      context.parent.onlyNumberMotor(e,targetObj);
    }
    function checkValidationEmailAndMobile(){
        if(props.selectedEndrsType == 'transferOfOwnership'){ 
            context.root.$set(props.addressData.correspondenceAddress.mobileNo, 'stepsMandatory', true);
            context.root.$set(props.addressData.correspondenceAddress.mobileNo, 'skip', undefined);
            context.root.$set(props.addressData.correspondenceAddress.emailId, 'stepsMandatory', true);
            context.root.$set(props.addressData.correspondenceAddress.emailId, 'skip', undefined);
            if(props.addressData.correspondenceAddress.emailId.value && props.addressData.correspondenceAddress.emailId.errorText==''){
                context.root.$set(props.addressData.correspondenceAddress.mobileNo, 'stepsMandatory', false);
                context.root.$set(props.addressData.correspondenceAddress.mobileNo, 'skip', true);
                if(props.addressData.correspondenceAddress.mobileNo.errorText == props.addressData.correspondenceAddress.mobileNo.errorMessage){
                    context.root.$set(props.addressData.correspondenceAddress.mobileNo, 'errorText', '');
                }
            }    
            else{
                if(props.addressData.correspondenceAddress.mobileNo.value && props.addressData.correspondenceAddress.mobileNo.errorText==''){
                    context.root.$set(props.addressData.correspondenceAddress.emailId, 'stepsMandatory', false);
                    context.root.$set(props.addressData.correspondenceAddress.emailId, 'skip', true);
                    if(props.addressData.correspondenceAddress.emailId.errorText == props.addressData.correspondenceAddress.emailId.errorMessage){ 
                        context.root.$set(props.addressData.correspondenceAddress.emailId, 'errorText', '');
                    }
                } 
            }
        }
        context.parent.calculateSteps();
    }
    function toUpperCase(){
      props.addressData.correspondenceAddress.panNumber.value=props.addressData.correspondenceAddress.panNumber.value.toUpperCase();
    }
    watch(() => [props.addressData.permanentAddress.pincode.value],(newVal,oldVal) =>{
      if(newVal != props.addressData.correspondenceAddress.pincode.value){
        if(Object.keys(props.addressData.permanentAddress.pincode.value).length == 6){
            callGetAreaByPinCode('fromNil','permanentAddress');
        }
      }
    })
    watch(() => [props.addressData.correspondenceAddress.pincode.value],(newVal,oldVal) =>{
      if(newVal != props.addressData.permanentAddress.pincode.value){
        if(props.selectedEndrsType == 'transferOfOwnership'){
            if(Object.keys(props.addressData.correspondenceAddress.pincode.value).length == 6){
                callGetAreaByPinCode('fromNil','correspondenceAddress');
            }
        }
      }
    })
    return {
      state,
      isFloat,
      checkError,
      isInputError,
      onlyNumber,
      onlyChar,
      addressOnly,
      onlyCharSpace,
      onlyNumberMotor,
      alphaNumeric,
      alphaNumericSpace,
      hidePresentAdd,
      callGetAreaByPinCode,
      changeEncryptionValidation,
      checkValidationEmailAndMobile,
      toUpperCase,
      validatePan,
      resetPanText
    //   getLanguage
    };
  },
   directives: {
    evolvews: functions.evolvews
  }
};
</script>
<style scoped>
/* pan no css */
.search-loader img{
  width: 25px;
  height: 25px;
  left: 80%;
  top: 37%;
  position: absolute;
}
.pan-validated.success-pan{
  color: green;
}
.pan-validated{
  color: #f77a7a;
  font-size: 13px;
  margin-top: 7px;
}
a.bgc-links.pan-search {
  text-decoration: underline;
  font-size: 14px;
  color: #0872b9;
  font-weight: 400;
}
.checkbox-inline {
  margin-top: 4px;
  margin-left: 15px;
  position: relative;
}
.pan-input{
  text-transform:uppercase;
}
::-webkit-input-placeholder { /* WebKit browsers */
  text-transform: none;
}
:-moz-placeholder { /* Mozilla Firefox 4 to 18 */
  text-transform: none;
}
::-moz-placeholder { /* Mozilla Firefox 19+ */
  text-transform: none;
}
:-ms-input-placeholder { /* Internet Explorer 10+ */
  text-transform: none;
}
::placeholder { /* Recent browsers */
  text-transform: none;
}
@media (min-width: 576px) and (max-width: 767px) {
  .checkbox-inline {
    margin-top: 15px;
    right: 12px;
    margin-left: 0px;
  }
}
@media (min-width: 768px) and (max-width: 920px) {
  .checkbox-inline {
    margin-top: 15px;
    right: 21px;
    margin-left: 0px;
  }
}
@media (max-width: 575px) {
  .checkbox-inline {
    margin-top: 15px;
    right: 42px;
  }
  .pan-search-div {
    margin-top: 0px;
  }
  .add-wrapper {
    line-height: 20px;
  }
}
@media (max-width: 380px) {
  .checkbox-inline {
    display: flex;
  }
}
</style>
